import styled from 'styled-components';

import { ScarcityIcon } from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Text14 } from '@sorare/core/src/atoms/typography';
import {
  playableBlockchainRarities,
  scarcityNames,
} from '@sorare/core/src/lib/cards';

const Rarities = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: var(--intermediate-unit) 0;
`;
const Rarity = styled(Vertical).attrs({ gap: 0.5, center: true })`
  justify-content: flex-start;
`;
const Count = styled(Text14)`
  background: var(--c-nd-100);
  border-radius: 50px;
  padding: 0 var(--unit);
`;

export type Props = {
  cardRewards: {
    limited: number;
    rare: number;
    super_rare: number;
    unique: number;
  };
};

export const CardRewards = ({ cardRewards }: Props) => {
  return (
    <Rarities>
      {playableBlockchainRarities.map(rarity => (
        <Rarity key={rarity}>
          <ScarcityIcon scarcity={rarity} size="lg" />
          <Text14 color="var(--c-nd-600)">{scarcityNames[rarity]}</Text14>
          <Count>x{cardRewards[rarity]}</Count>
        </Rarity>
      ))}
    </Rarities>
  );
};
